import { render } from "./FilteringThreshold.vue?vue&type=template&id=d01a86da&scoped=true"
import script from "./FilteringThreshold.vue?vue&type=script&lang=js"
export * from "./FilteringThreshold.vue?vue&type=script&lang=js"

import "./FilteringThreshold.vue?vue&type=style&index=0&id=d01a86da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01a86da"]])

export default __exports__